import React, { lazy, Suspense } from "react";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { renderRoutes } from "react-router-config";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "./app.css";
import { rootRoutes } from "./Routes";

const TopbarFooterLayout = () => {
  return <div className="layout">{renderRoutes(rootRoutes)}</div>;
};

const App = () => {
  return (
    <Suspense fallback={<span>Loading...</span>}>
      <ReactNotifications />
      <Router>
        <Switch>
          <Route
            path="/page"
            exact
            component={lazy(() => import("./views/Page"))}
          />
          <Route
            path="/exp3-content"
            exact
            component={lazy(() => import("./views/Exp3Content"))}
          />
          <Route
            path="/payment-success"
            exact
            component={lazy(() => import("./views/PaymentSuccess"))}
          />
          <Route
            path="/test"
            exact
            component={lazy(() => import("./views/Page2"))}
          />
          <Route path="/" component={TopbarFooterLayout} />
        </Switch>
      </Router>
    </Suspense>
  );
};

export default App;
